const theme = {
  mobile: '600px',
  tablet: '800px',
  maxWidth: '996px',
  headerHeight: '5.5rem',
  footerHeight: '27.75rem',
  footerMobileHeight: '22rem',
  navBarHeight: '3.75rem',
};

export default theme;
